import _ from 'lodash';

import { setError } from '../App/ErrorsActions';

import customFieldsUtils from '../../util/customFieldsUtils';
import CalculationsWorker from '../../services/worker';

export const ERROR = 'CTSP_ERROR';
export const LOADING = 'CTSP_LOADING';
export const SUCCESS = 'CTSP_SUCCESS';
export const SUCCESS_DETAILED_PERCENTILES = 'CTSP_SUCCESS_DETAILED_PERCENTILES';

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

export function success(data, percentileTrends) {
  return {
    type: SUCCESS,
    data,
    percentileTrends
  };
}

function successDetailedPerccentiles(data) {
  return {
    type: SUCCESS_DETAILED_PERCENTILES,
    data
  };
}

export function getData() {
  return async (dispatch, getState) => {
    dispatch(isLoading(true));

    const { user } = getState().auth;
    const { selected } = getState().dashboards;
    const { data } = getState().app;

    const allFilters = getState().filters;
    const {
      chart,
      allCustomFields,
      excludeWeekends,
      workStart,
      workEnd,
      holidays,
      enabledColors,
      dates,
      ctsp
    } = allFilters;
    const filters = chart === 'overview' ? allFilters.overview : ctsp;

    const customFields = customFieldsUtils.getSelected(allCustomFields, filters);

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, enabledColors, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });
    try {
      const ctspData = await worker.CycleTimeScatterPlot({
        lists: filters.selectedLists,
        labels: filters.selectedLabels,
        members: filters.selectedMembers,
        customFields,
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        timeUnit: ctsp.timeUnit,
        blockedTime: ctsp.blockedTime,
        blockers: ctsp.blockers,
        selectedDate: ctsp.selectedDate,
        color: true,
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        percentiles: allFilters.allPercentileValues,
        useWorkingHoursInCycleTimeDays: user.config && user.config.useWorkingHoursInCycleTimeDays
      });

      const percentileTrends = await worker.PercentileTrends({
        data: ctspData.series,
        percentiles: allFilters.allPercentileValues,
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        useWorkingHoursInCycleTimeDays: user.config && user.config.useWorkingHoursInCycleTimeDays
      });

      dispatch(success(ctspData, percentileTrends));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}

export function getDetailedPercentiles(ctspData, percentiles) {
  return async (dispatch, getState) => {
    try {
      const { selected } = getState().dashboards;
      const { data } = getState().app;

      const service = new CalculationsWorker();
      let worker = service.wrap();
      worker = await new worker(selected, data);

      const flatData = _.flatMap(ctspData, d => {
        return d.data;
      });
      const percentilesData = await worker.GetPercentileDetails(flatData, percentiles);
      dispatch(successDetailedPerccentiles(percentilesData));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}
